import { ENV } from '../constants';
// enable reduxDevTool
export default function reducDevTool() {
    return (
        process.env.REACT_APP_ENV === ENV.LOCAL &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()
    );
}
